"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParticipantFacingEcoaActivity = isParticipantFacingEcoaActivity;
exports.isParticipantFacingStudyResource = isParticipantFacingStudyResource;
function isParticipantFacingEcoaActivity(activity, options = { includeClinicianInterviewClinros: true }) {
    var _a, _b, _c;
    const instrumentType = (_b = (_a = activity === null || activity === void 0 ? void 0 : activity.activity_metadata) === null || _a === void 0 ? void 0 : _a.instrument_type) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
    if (!instrumentType) {
        throw new Error('Activity instrument type is required');
    }
    if (instrumentType === 'pro' || instrumentType === 'obsro') {
        return true;
    }
    if (instrumentType === 'clinro' &&
        ((_c = activity === null || activity === void 0 ? void 0 : activity.activity_metadata) === null || _c === void 0 ? void 0 : _c.is_clinician_interview) === true &&
        options.includeClinicianInterviewClinros) {
        return true;
    }
    return false;
}
function isParticipantFacingStudyResource(availableTo) {
    return availableTo === 'patient_only' || availableTo === 'site_patient';
}
//# sourceMappingURL=activity.js.map